import { addons } from '@storybook/manager-api'
import yourTheme from './theme'

addons.setConfig({
  theme: yourTheme
})